import { Card, CardBody, Col, Row } from "reactstrap";
import dummyWeekendDealPhoto from "../../assets/weekend-deal-photo.png";
import { showInFullScreen } from "../specials/FullScreenView";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDealsHooks } from "../../hooks/useDealsHooks";
import AddDeals from "../modals/AddDeals";
import { usePlaceHooks } from "../../hooks/UsePlacesHooks";
import { useTranslation } from "../../languages";

const ResturantDeals = (detail) => {
  const deals_Redux = useSelector((s) => s?.allDealsData);
  const [dealsData, setDealsData] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    if (deals_Redux?.length > 0) {
      let dealsFilterDaata = deals_Redux?.filter(
        (i) => i?.place === detail?.details?._id
      );
      console.log("deals data", dealsFilterDaata);
      setDealsData(dealsFilterDaata);
    }
  }, [deals_Redux, detail]);

  const {
    //all local states

    editDealsModal,
    setEditDealsModal,
    //all functions
    onPressDealsItemEditBtn,
    dealData,
    handleClearData,
    handleDaysSelect,
    setDealData,
    onPressEditBtn,
  } = useDealsHooks();

  const {
    // all functions for my places
  } = usePlaceHooks();

  return (
    <div>
      <h4
        style={{ letterSpacing: "9px" }}
        className="f-5 text-white my-3 text-center"
      >
        {t("bestDeals")}
      </h4>
      <div className="resturant-detail-div  ">
        <Card className="bg-transparent border-none p-0 border-none ">
          <CardBody className=" py-0">
            <div
              // style={{
              //   height: "80vh",
              //   overflowY: "scroll",
              //   scrollSnapType: "y mandatory", // <== scroll snapping on Y axis
              //   scrollbarWidth: "none", // for Firefox
              //   msOverflowStyle: "none", // for Id Edge
              // }}
              className="no-scrollbar"
            >
              {dealsData?.length > 0 ? (
                <>
                  {dealsData?.map((item, at) => (
                    <div key={at} style={{ height: "80vh" }}>
                      <h3 className="f-6 text-center margin-top-14px mb-3 color-primary-gold">
                        {item?.title}
                      </h3>
                      <img
                        onClick={(e) =>
                          showInFullScreen(e?.target, [item?.picture])
                        }
                        src={item?.picture}
                        alt="deal-photo"
                        height={390}
                        style={{
                          borderRadius: "6.58px",
                          border: "1.85px solid rgba(202, 149, 69, 1)",
                        }}
                        className="object-fit-cover clickable-photo full-width mb-2"
                      />
                      <h2 className="f-5 color-primary-dark-brown text-center mb-3 mt-3">
                        {item?.itemName}
                      </h2>
                      <h2 className="f-5 mb-3">
                        {t("price")}:{" "}
                        <span className="color-primary-blue f-6">
                          ${item?.price}
                        </span>
                      </h2>
                      <h4 className="f-4 mb-4">{item?.description}</h4>
                      <Row className="mt-0 mx-0 mb-4 g-0">
                        <Col md={7}>
                          <h4 className="f-5 m-0">
                            {t("onEvery")}:{" "}
                            <span className="color-primary-blue f-6">
                              {item?.days?.join(" & ")}
                            </span>
                          </h4>
                        </Col>
                        <Col md={5}>
                          <h4 className="f-5 m-0">
                            {t("from")}:{" "}
                            <span className="color-primary-blue f-6">
                              {item?.timeSlot?.from} to {item?.timeSlot?.to}
                            </span>
                          </h4>
                        </Col>

                        <button
                          className="btn color-primary-blue btn-md  border-none f-5 bg-primary-half-blue py-md-3 py-2 mt-5 fs-4 text-bold"
                          onClick={() => onPressDealsItemEditBtn(item)}
                        >
                          {t("editDeals")}
                        </button>
                      </Row>
                    </div>
                  ))}
                </>
              ) : (
                <div className="d-flex justify-content-center align-items-center fw-bolder text-white fs-1">
                  {t("forThisPlaceNoDealsAddedYet")}
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      </div>

      <AddDeals
        isOpen={editDealsModal}
        setisOpen={setEditDealsModal}
        edit={true}
        dealData={dealData}
        setDealData={setDealData}
        handleClearData={handleClearData}
        handleDaysSelect={handleDaysSelect}
        onPressEditBtn={onPressEditBtn}
      />
    </div>
  );
};

export default ResturantDeals;
